import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-query-success",
  "use": "icon-query-success-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-query-success\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0a512 512 0 1 1 0 1024 512 512 0 0 1 0-1024z m209.650526 320.134737l-304.936421 304.774737-152.414316-152.360421-38.103578 38.103579 190.517894 190.517894 38.103579-38.103579 304.882527-304.882526-38.103579-38.103579z\" p-id=\"3612\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol